import { AxiosInstance } from "./axiosInstance";
import {
  NotificationCountResponse,
  NotificationListRequest,
  NotificationMarkRequest,
  NotificationMarkResponse,
  NotificationReadMark,
} from "./interfaces/notificationInterface.interface";

const NOTIFICATION_API_PATH = "/notification";

//리스트 조회
export const getNotification = async (params: NotificationListRequest) => {
  try {
    const response = await AxiosInstance.get(`${NOTIFICATION_API_PATH}/list`, {
      params,
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error("Notification API Error:", error);
  }
};

//카운트 조회
export const getNotificationCount = async ({
  email,
}: {
  email: string;
}): Promise<NotificationCountResponse | undefined> => {
  try {
    const response = await AxiosInstance.get(`${NOTIFICATION_API_PATH}/count`, {
      params: {
        email,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};

//모든 알림 읽음 처리
export const postAllRead = async ({
  email,
}: {
  email: string;
  isRead: boolean;
}): Promise<void> => {
  try {
    const response = await AxiosInstance.post(
      `${NOTIFICATION_API_PATH}/allReadMark`,
      {
        email,
        isRead: true,
      }
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};
//첫 조회시 첫 알림 전달
export const postFirstNotification = async ({
  email,
  notiId,
  notiTime,
}: NotificationMarkRequest): Promise<NotificationMarkResponse | undefined> => {
  try {
    const response = await AxiosInstance.post(`${NOTIFICATION_API_PATH}/mark`, {
      email: email,
      notiId: notiId,
      notiTime: notiTime,
      isRead: true,
    });
    if (response.status === 200) {
      return {
        email: email,
        notiId: notiId,
        notiTime: notiTime,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

//읽음 처리
export const postNotificationRead = async (
  payload: NotificationReadMark
): Promise<NotificationReadMark | undefined> => {
  try {
    const response = await AxiosInstance.post(
      `${NOTIFICATION_API_PATH}/readMark`,
      payload
    );
    if (response.status === 200) {
      return payload;
    }
  } catch (error) {
    console.error(error);
  }
};
